import { HomePaths } from '@/modules/Paths';
import { useAttentionTracker } from 'app/[locale]/hooks/useAttentionTracker';
import { useTranslate } from 'app/[locale]/hooks/useTranslate';
import analyticsInstance from 'libs/rtzr-commons/modules/marketing/Analytics';
import Image from 'next/image';
import Link from 'next/link';

export const SecuritySection = (): JSX.Element => {
  const { t } = useTranslate();
  const { ref } = useAttentionTracker({ sectionName: 'main_security' });

  return (
    <section className="text-center px-4 md:px-10 bg-blue-pale py-20" ref={ref}>
      <h2 className="flex gap-1 md:gap-2 justify-center items-center text-xl font-semibold text-black-light md:text-[3rem] md:leading-[normal] text-center">
        {t.home.MAIN_SECURITY_TITLE_1}
        <Image
          className="md:w-[80px] w-[40px] aspect-square"
          src="/callabo/security/ISO_27001_logo.svg"
          width={80}
          height={80}
          alt="ISO Logo"
        />
        {t.home.MAIN_SECURITY_TITLE_2}
      </h2>
      <p
        className="text-sm md:text-xl text-black-light md:leading-[150%] mt-3.5 md:mt-6"
        dangerouslySetInnerHTML={{ __html: t.home.MAIN_SECURITY_DESC }}
      />
      <Link href={HomePaths.Security} passHref>
        <button
          onMouseDown={() => {
            analyticsInstance.logEvent(`click_go_to_page`, {
              page_url: HomePaths.Security,
            });
          }}
          className="inline-block text-primary font-semibold text-sm md:text-xl md:leading-[150%] mt-3.5 md:mt-2"
        >
          {t.home.MAIN_SECURITY_BUTTON}
        </button>
      </Link>
    </section>
  );
};
